(function ($) {
  Drupal.behaviors.foundationFinderMerchWindowV1 = {
    attach: function (context, settings) {
      $('.foundation-finder-merch-window-v1').each(function () {
        var thisFormatter = $(this);
        var link = thisFormatter.find('.button').attr('href');

        if (typeof link !== 'undefined') {
          thisFormatter.wrapInner('<a class="blueOceanQuizButton" href="' + link + '" style="display:block;overflow:hidden;"></a>');
          Drupal.behaviors.launchFoundationFinder.attach(thisFormatter);
        }
      });
    }
  };
})(jQuery);
